// extracted by mini-css-extract-plugin
export default {"MyPhoto":"AboutMeSidebar_MyPhoto__Q9Tsv"};